import React, { Fragment, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { renderTimeMonth } from "../../Utils/functions";
import CustomModal from "../CustomModal/index";
import { useCommnet } from "./Hooks";

const Commonets = ({ id, rel, comments }) => {
  const {
    renderImg,
    renderData,
    user,
    form,
    setForm,
    loadingBtn,
    storeComment,
  } = useCommnet({ id, rel });
  console.log("d", user);
  return (
    <>
      <div
        className="web-template"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div className="d-flex  align-items-center">
          <img
            src={renderImg()}
            alt={user?.user?.fullname || "عکس کاربر"}
            style={{ width: "30px", height: "30px", borderRadius: "15px" }}
          />
          <h6
            style={{
              fontWeight: "400",
            }}
          >
            {user?.user?.fullname}
          </h6>
        </div>
        <div>
          <button
            className="btn btn-blue px-5"
            onClick={() => {
              if (!user.access_token) {
                toast.error("برای ثبت نظر ابتدا باید ثبت نام کنید");
              } else {
                setForm({ ...form, modal: true });
              }
            }}
          >
            ثبت نظر
          </button>
        </div>
      </div>
      <div className="web-template" style={{}}>
        {comments.data.length === 0 ? (
          <p
            className="h6 text-center mt-5 mb-4"
            style={{
              fontWeight: "400",
            }}
          >
            نظری برای این مقاله ثبت نشده است !
          </p>
        ) : (
          comments.data.map((item, i) => {
            return (
              <Fragment key={i}>
                <div className="row">
                  <div className="comentbox web-template" style={{}}>
                    <div
                      className="right-side d-flex border-bottom"
                      style={{
                        paddingBottom: "7px",
                      }}
                    >
                      <img
                        src={require("../../Assets/images/comment.png")}
                        alt="nikotan | نیکوتن"
                        className="rounded-circle"
                        height={30}
                        width={30}
                      />
                      <div style={{ marginRight: "10px" }}>
                        <p
                          style={{
                            color: "#404040",
                            fontSize: "15px",
                            fontWeight: "400",
                          }}
                        >
                          {item.commenter && item.commenter.fullname}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#929292",
                            fontWeight: "400",
                          }}
                        >
                          {renderTimeMonth(item.created_at)}
                        </p>
                      </div>
                    </div>
                    <div className="left-side">
                      <div>
                        {/* <RateRender
                          data={item.score}
                          styles={{ display: "flex", justifyContent: "right" }}
                        /> */}
                      </div>
                      <div>
                        <p
                          style={{
                            fontSize: "13px",
                            marginRight: "10px",
                            marginTop: "7px",
                            color: "#000",
                            textAlign: "justify",
                            fontWeight: "400",
                          }}
                        >
                          {item.text}
                        </p>
                      </div>
                      {item.reply &&
                        item.reply.map((reply, key) => {
                          return (
                            <div
                              className="row justify-content-end mt-3"
                              key={key}
                            >
                              <div className="comentbox-rep col-md-11">
                                <div className="right-side-rep d-flex align-items-center">
                                  <img
                                    src={renderData(reply)["img"]}
                                    alt="nikotan | نیکوتن"
                                    className=""
                                    height={30}
                                  />
                                  <div style={{ marginRight: "10px" }}>
                                    {" "}
                                    <p
                                      className="name-comenter"
                                      style={{
                                        color: "#000",
                                      }}
                                    >
                                      {renderData(reply)["text"]}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: "#929292",
                                      }}
                                    >
                                      {renderTimeMonth(item.created_at)}
                                    </p>
                                  </div>
                                </div>
                                <div className="left-side-rep">
                                  <div>
                                    <p
                                      style={{
                                        fontSize: "13px",

                                        color: "#929292",
                                        textAlign: "justify",
                                      }}
                                    >
                                      {reply.text}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </Fragment>
            );
          })
        )}
        {comments.data.length > 10 ? (
          <div className="see-more d-flex justify-content-center">
            <a href="#" className="btn shadow-sm border rounded-15 py-2 px-5">
              مشاهده موارد بیشتر
            </a>
          </div>
        ) : null}

        <CustomModal
          show={form.modal}
          size="md"
          header={"افزودن دیدگاه"}
          handleClose={() => setForm({ ...form, modal: false })}
        >
          <AddComment
            id={id}
            type={form.modal}
            storeComment={storeComment}
            loadingBtn={loadingBtn}
            rel={rel}
          />
        </CustomModal>
      </div>
    </>
  );
};

export default Commonets;
const AddComment = ({ type, storeComment, loadingBtn, rel, id }) => {
  const [state, setState] = useState({ text: "" });

  return (
    <div className="">
      <form className=" rounded-15 p-2 ">
        <div className="row md-margin-need">
          <div className="col mb-2">
            <textarea
              rows={6}
              type="text"
              className="form-control"
              placeholder="نظر شما ..."
              onChange={e => {
                setState({
                  text: e.target.value,
                });
              }}
            />
          </div>
        </div>

        <div className="row mt-md-2 d-flex mx-1 md-margin-need justify-content-end">
          {/* <div className="col-md-4"> */}
          <button
            type="button"
            className="btn btn-blue"
            onClick={() => storeComment(state.text)}
            disabled={loadingBtn || !state.text}
            style={{
              fontSize: "16px",
            }}
          >
            {loadingBtn ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "ارسال نظر"
            )}
          </button>
          {/* </div> */}
        </div>
      </form>
    </div>
  );
};
